import { LoaderFunctionArgs } from 'react-router';
import { fetchNomenclature } from '../services';

export const nomenclaturePageLoader = async ({
  params,
}: LoaderFunctionArgs) => {
  const id = String(params.id);

  if (id === 'new') {
    return { data: null };
  }

  try {
    const data = await fetchNomenclature({ id });
    return { data };
  } catch (error) {
    return { data: null };
  }
};
